import { Col, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';

const { TextArea } = Input;

export default function ExpandTypeEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**需求类型数据 */
    const [expandCategoryData, setExpandCategoryData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = "";

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {

                }
            })
        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "expandCategory",
                apiExtend: 'showList',
            }).then(async res => {
                if (res.success) {
                    await setNewData(res.data, setExpandCategoryData);
                }
            })
        }
        fetchData()
    }, [])

    const setNewData = async (rows: any, setData: any) => {
        let finalData: any = [];
        let childrenData: any = [];

        await fetchApi.GET(wmService, {
            apiId: "generalData",
            apiExtend: 'showList',
            apiVariable: "menuWarehouseRequireMent",
        }).then(res => {
            if (res.success) {
                let rowsData = res.data;
                for (let i = 0; i < rowsData.length; i++) {
                    for (let j = 0; j < rows.length; j++) {
                        if (rows[j].menuWarehouseRequireMentId === rowsData[i].id) {
                            childrenData.push({
                                label: rows[j].expandCategoryName, value: rows[j].id
                            })
                        }
                    }
                    finalData.push({
                        label: rowsData[i].name,
                        title: rowsData[i].name,
                        options: childrenData
                    })
                    childrenData = [];
                }
            }
        })
        setData(finalData);
    }

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'expandType'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '需求内容'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求类型"
                                name="expandCategoryId"
                                rules={[{ required: true, message: '请选择需求类型!' }]}
                            >
                                <Select
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    options={expandCategoryData}
                                >
                                    {/* {getList.generalEx(expandCategoryData, {
                                        itemName: "expandCategoryName",
                                        includeNull: false
                                    })} */}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求内容"
                                name="expandTypeName"
                                rules={[{ required: true, message: '请输入需求内容!' }]}>
                                <TextArea
                                    placeholder="需求内容"
                                    autoSize={{ minRows: 3, maxRows: 6 }}
                                    showCount maxLength={250}
                                />
                            </Form.Item>
                        </Col>


                        <Col span={24}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}